// UserModal.js
import axios from 'axios';
import React, { useState, useEffect } from 'react';
import { useCookies } from 'react-cookie';
const UserModal = ({ type, user, onClose, onSubmit, getRoleName }) => {
   const [cookie, setCookie] = useCookies(["access_token"])
 const token = cookie.token
  const [formData, setFormData] = useState({
    firstName: '',
    lastName: '',
    email: '',
    department: '',
    batch: '',
    profileLevel: 3,
    password: 'Tester@123'
  });

  const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:5000';

  useEffect(() => {
    if (user && (type === 'edit' || type === 'promote')) {
      setFormData({
        firstName: user.firstName || '',
        lastName: user.lastName || '',
        email: user.email || '',
        department: user.department || '',
        batch: user.batch || '',
        profileLevel: user.profileLevel || 3,
        // password: user.password || ''
      });
    }
  }, [user, type]);

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      if (type === 'add') {
             const config = {
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${token}`
          }
        };
        const response = await axios.post(`${API_URL}/alumni/super-admin/register`, {
          ...formData,
          userType: getTypeFromProfileLevel(formData.profileLevel),
          admin: formData.profileLevel === 0 || formData.profileLevel === 1
        },config);

        if (response.data.success) {
          onSubmit();
          onClose();
          alert('User created successfully!');
        } else {
          alert(`Failed to create user: ${response.data.message || 'Unknown error'}`);
        }
      } else if (type === 'edit') {
        const config = {
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${token}`
          }
        };
        const response = await axios.put(`${API_URL}/alumni/super-admin/${user._id}`, formData, config);

        if (response?.status === 200) {
          onSubmit();
          onClose();
          alert('User updated successfully!');
        } else {
          alert('Failed to update user');
        }
      } else if (type === 'promote') {
        onSubmit(user._id, formData.profileLevel);
      }
    } catch (error) {
      console.error('Error:', error);
      alert('An error occurred');
    }
  };

  const getTypeFromProfileLevel = (level) => {
    switch(level) {
      case 0: return 'admin';
      case 1: return 'admin';
      case 2: return 'alumni';
      case 3: return 'student';
      default: return 'student';
    }
  };

  const handleBackdropClick = (e) => {
    if (e.target === e.currentTarget) {
      onClose();
    }
  };

  return (
    <div 
      className="fixed inset-0 bg-black/50 backdrop-blur-sm flex items-center justify-center p-4 z-[9999]"
      onClick={handleBackdropClick}
    >
      <div className="bg-white rounded-2xl max-w-lg w-full max-h-[90vh] overflow-y-auto border border-gray-200 shadow-2xl">
        <div className="sticky top-0 bg-gradient-to-r from-blue-500 to-indigo-600 px-6 py-4 rounded-t-2xl">
          <div className="flex justify-between items-center">
            <h2 className="text-2xl font-bold text-white">
              {type === 'add' && '➕ Add New User'}
              {type === 'edit' && '✏️ Edit User'}
              {type === 'promote' && '🔄 Change User Role'}
            </h2>
            <button 
              className="text-white hover:text-red-200 text-2xl transition-colors p-1 hover:bg-white/20 rounded-lg"
              onClick={onClose}
            >
              ✕
            </button>
          </div>
        </div>
        
        <form onSubmit={handleSubmit} className="p-6 space-y-6">
          {type !== 'promote' && (
            <>
              <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                <div>
                  <label className="block text-gray-700 font-semibold mb-2">First Name *</label>
                  <input
                    type="text"
                    value={formData.firstName}
                    onChange={(e) => setFormData({...formData, firstName: e.target.value})}
                    className="w-full px-4 py-3 bg-gray-50 text-gray-800 placeholder-gray-500 rounded-xl border border-gray-300 focus:border-blue-500 focus:outline-none focus:ring-2 focus:ring-blue-200 transition-all"
                    required
                    placeholder="Enter first name"
                  />
                </div>
                
                <div>
                  <label className="block text-gray-700 font-semibold mb-2">Last Name *</label>
                  <input
                    type="text"
                    value={formData.lastName}
                    onChange={(e) => setFormData({...formData, lastName: e.target.value})}
                    className="w-full px-4 py-3 bg-gray-50 text-gray-800 placeholder-gray-500 rounded-xl border border-gray-300 focus:border-blue-500 focus:outline-none focus:ring-2 focus:ring-blue-200 transition-all"
                    required
                    placeholder="Enter last name"
                  />
                </div>
              </div>
              
              <div>
                <label className="block text-gray-700 font-semibold mb-2">Email *</label>
                <input
                  type="email"
                  value={formData.email}
                  onChange={(e) => setFormData({...formData, email: e.target.value})}
                  className={`w-full px-4 py-3 bg-gray-50 text-gray-800 placeholder-gray-500 rounded-xl border border-gray-300 focus:border-blue-500 focus:outline-none focus:ring-2 focus:ring-blue-200 transition-all ${
                    type === 'edit' ? 'opacity-50 cursor-not-allowed' : ''
                  }`}
                  required
                  disabled={type === 'edit'}
                  placeholder="Enter email address"
                />
              </div>
              
              <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                <div>
                  <label className="block text-gray-700 font-semibold mb-2">Department</label>
                  <input
                    type="text"
                    value={formData.department}
                    onChange={(e) => setFormData({...formData, department: e.target.value})}
                    className="w-full px-4 py-3 bg-gray-50 text-gray-800 placeholder-gray-500 rounded-xl border border-gray-300 focus:border-blue-500 focus:outline-none focus:ring-2 focus:ring-blue-200 transition-all"
                    placeholder="Enter department"
                  />
                </div>
                
                <div>
                  <label className="block text-gray-700 font-semibold mb-2">Batch</label>
                  <input
                    type="text"
                    value={formData.batch}
                    onChange={(e) => setFormData({...formData, batch: e.target.value})}
                    className="w-full px-4 py-3 bg-gray-50 text-gray-800 placeholder-gray-500 rounded-xl border border-gray-300 focus:border-blue-500 focus:outline-none focus:ring-2 focus:ring-blue-200 transition-all"
                    placeholder="Enter batch"
                  />
                </div>
              </div>
            </>
          )}

          <div>
            <label className="block text-gray-700 font-semibold mb-2">Role *</label>
            <select
              value={formData.profileLevel}
              onChange={(e) => setFormData({...formData, profileLevel: parseInt(e.target.value)})}
              className="w-full px-4 py-3 bg-gray-50 text-gray-800 rounded-xl border border-gray-300 focus:border-blue-500 focus:outline-none focus:ring-2 focus:ring-blue-200 transition-all"
              required
            >
              <option value={1}>🛡️ Admin</option>
              <option value={0}>👑 Super Admin</option>
              
            </select>
          </div>

          {type === 'promote' && user && (
            <div className="bg-gradient-to-r from-blue-50 to-indigo-50 p-4 rounded-xl border border-blue-200">
              <h3 className="text-gray-800 font-semibold mb-3">Role Change Summary</h3>
              <div className="space-y-2">
                <p className="text-gray-700">
                  <span className="font-medium">Current Role:</span> 
                  <span className="ml-2 px-3 py-1 bg-red-100 text-red-700 rounded-lg text-sm font-semibold">
                    {getRoleName(user.profileLevel)}
                  </span>
                </p>
                <p className="text-gray-700">
                  <span className="font-medium">New Role:</span> 
                  <span className="ml-2 px-3 py-1 bg-green-100 text-green-700 rounded-lg text-sm font-semibold">
                    {getRoleName(formData.profileLevel)}
                  </span>
                </p>
              </div>
            </div>
          )}

          <div className="flex space-x-4 pt-4">
            <button 
              type="button" 
              className="flex-1 bg-gray-100 hover:bg-gray-200 text-gray-700 py-3 rounded-xl font-semibold transition-all duration-200 border border-gray-300"
              onClick={onClose}
            >
              Cancel
            </button>
            <button 
              type="submit" 
              className="flex-1 bg-gradient-to-r from-blue-500 to-indigo-600 hover:from-blue-600 hover:to-indigo-700 text-white py-3 rounded-xl font-semibold transition-all duration-200 shadow-lg hover:shadow-xl transform hover:-translate-y-1"
            >
              {type === 'add' && 'Create User'}
              {type === 'edit' && 'Update User'}
              {type === 'promote' && 'Change Role'}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default UserModal;
